const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '先进CDN分发技术，视频秒开零等待，高清画质流畅播放不缓冲。',
  },
  {
    icon: 'ri-film-line',
    title: '海量片库',
    desc: '覆盖电影、电视剧、综艺、动漫、纪录片全品类，每日新增50+部内容。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '支持电脑、平板、手机无缝切换，追剧进度跨设备自动同步。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '高清画质',
    desc: '全线支持1080P高清播放，部分热门内容提供4K超清画质选项。',
  },
  {
    icon: 'ri-notification-3-line',
    title: '追剧提醒',
    desc: '自定义追剧列表，剧集更新第一时间推送通知，不错过任何精彩。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            为什么选择极速影视
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto leading-relaxed">
            五大核心优势，打造极致追剧体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((feat, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 text-center group cursor-pointer hover:-translate-y-1 transition-all"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                {feat.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}